import { render, staticRenderFns } from "./CustomersSvg.vue?vue&type=template&id=32fa3ecf"
import script from "./CustomersSvg.vue?vue&type=script&lang=js"
export * from "./CustomersSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports